import angular from 'angular';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function TrainingAdminMediaListDirectiveController(
  $rootScope,
  $q,

  alerts,
  eduDataService,
  loaderService,
  ssDialogService,
  trainingAdminEditMediaDialog
) {
  const vm = this;

  vm.handleMediaMove = _handleMediaMove;
  vm.handleInserted = _handleInserted;
  vm.handleAddMediaClick = _handleAddMediaClick;

  function _handleMediaMove($index, section) {
    section.medias.splice($index, 1);
  }

  function _handleInserted(idx, section, media) {
    // Transform media list into object of mediaId/Sort Order pairs for persisting
    const mediaKeySortOrderValue = [];
    angular.forEach(section.medias, (m, index) => {
      if (media.mediaId !== m.mediaId || idx === index) {
        mediaKeySortOrderValue.push({ key: m.mediaId, value: index + 1 });
      }
    });

    loaderService.showViewLoader = true;
    eduDataService.saveMediaSortOrder(
      section.sectionId,
      mediaKeySortOrderValue
    ).then(() => {
      alerts.success(copy.admin.trainingAdministration.alerts.moveMediaSuccessful.text);
      loaderService.showViewLoader = false;
      $rootScope.$broadcast('refreshEduMedia');
    });
  }

  function _handleAddMediaClick($event, topic, section) {
    ssDialogService.dialogs.admin.editTrainingMediaDialog = ssDialogService.alert(
      trainingAdminEditMediaDialog.getOptions($event, {
        topic,
        section,
        media: {
          mediaId: 0,
        },
      }) // template: require('./media-item.directive.html'),
    );
    ssDialogService.show(ssDialogService.dialogs.admin.editTrainingMediaDialog);
  }
}

TrainingAdminMediaListDirectiveController.$inject = [
  '$rootScope',
  '$q',

  'alerts',
  'eduDataService',
  'loaderService',
  'ssDialogService',
  'trainingAdminEditMediaDialog'
];
